import { useQuery } from "@tanstack/react-query";
import Image from "next/image";
import { UseFormReturn, useWatch } from "react-hook-form";

import { getProduct } from "../../core/product.core";
import { useTranslation } from "../../core/translation.core";
import CloseIcon from "../../icons/iconClose.comp";
import { ProductFormData } from "../../types/product";
import LocalePs from "../locale/localePs.core";
import ProductSearchInput from "./productSearchInput.core";
import ProductSearchList from "./productSearchList.comp";

export default function RelatedProductsInput({ methods }: { methods: UseFormReturn<ProductFormData, any> }) {
  const { t, msg } = useTranslation();

  function addProduct(productId: string) {
    const productIds: string[] = methods.getValues("relatedProductIds");
    const newProductIds = Array.from(new Set(productIds).add(productId));
    methods.setValue("relatedProductIds", newProductIds as never);
  }

  function removeProduct(productId: string) {
    const productIds: string[] = methods.getValues("relatedProductIds");
    const newProductIds = productIds.filter((p) => p !== productId);
    methods.setValue("relatedProductIds", newProductIds as never);
  }

  const productIds = useWatch({
    control: methods.control,
    name: "relatedProductIds",
  });

  return (
    <div id="related-products" className="max-h-80">
      <label className="mb-2 block">{t(msg.product.relatedProducts)}</label>
      <ProductSearchInput addProduct={addProduct} />
      <ProductSearchList selectedProductIds={productIds} removeProduct={removeProduct} />
    </div>
  );
}
